// lista de incidentes activas segun filtro
import React, { useContext, useState } from "react";
import { AppContext } from "./index";
import { bkCabGrilla, clCabGrilla, colores, diaMes, sizeCelda, sizeCabezal, bkCeldaGrilla, clCeldaGrilla, bkSeleccion, bbottomGrilla } from "./general.js";
import buscador from "./img/buscador.png";


export default function ListaIncidentes({ tipo, prioridad, categoria, estado, persona, plazo, setFuncion, setIncidente }) {
  let { firebase } = useContext(AppContext);
  let color = colores["prioridad"];

  const [filtroBusqueda, setFiltroBusqueda] = useState(" ");

  return (
    <div style={Sincidentes}>
      <div id="listaincidentes" style={Slista}>
        <div style={SmarcoBuscador}>
          <img src={buscador} height="30px" width="30px" alt="?" onClick={() => setFiltroBusqueda(document.getElementById("filtro").value)} />
          <input id="filtro" type="text" size="100" autoComplete="off" style={{ marginLeft: "10px" }} />
        </div>
        <CabezalIncidentes />
        <div style={SlistaIncidentes}>
          {firebase.incidentes(tipo, prioridad, categoria, estado, persona, plazo, filtroBusqueda, true).map((i) => (
            <div
              id={i.id}
              style={SdetalleIncidente}
              key={i.id}
              onMouseEnter={(e) => (e.currentTarget.style.background = bkSeleccion)}
              onMouseLeave={(e) => (e.currentTarget.style.background = bkCeldaGrilla)}
              onClick={() => {
                setIncidente(i);
                setFuncion("Incidente");
              }}
            >
              <div style={Scelda}> {i.id} </div>
              <div style={Scelda}>{i.estado}</div>
              <div style={Scelda}>{i.tipo.substr(0, 1).toUpperCase()}</div>
              <div style={Scelda}>{diaMes(i.fechaRegistro, 1)}</div>
              <div style={Scelda}>{i.categoria}</div>
              <div style={Scelda}>{i.descripcion.toString().substr(0, 190)}</div>
              <div style={Scelda}>{diaMes(i.finEstimado, 1)}</div>
              <div style={Scelda}>
                <i className="material-icons" style={{ fontSize: "3vh", color: `${color[i.prioridad]}` }}>
                  flag
                </i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function CabezalIncidentes() {
  return (
    <div style={ScabezalIncidentes}>
      <div style={ScabInc}>
        <div>Id </div>
        <div>Estado</div>
        <div>Tipo</div>
        <div>Registro</div>
        <div>Categoría</div>
        <div>Descripción</div>
        <div>Fin Est.</div>
        <div>Prt.</div>
      </div>
    </div>
  );
}

const Sincidentes = {
  position: "relative",
  margin: "15px",
};

const SmarcoBuscador = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  minWidth: "70vw",
  cursor: "pointer",
  marginBottom: "10px"
};

const Slista = {
  position: "absolute",
  width: "91vw",
};

const ScabezalIncidentes = {
  fontSize: sizeCabezal,
  fontWeight: "700",
  background: bkCabGrilla,
  padding: "8px 0px 8px 0px",
  color: clCabGrilla
};

const SlistaIncidentes = {
  height: "70vh",
  overflowY: "auto",
  marginTop: "6px",
  cursor: "pointer"
};

const SdetalleIncidente = {
  display: "grid",
  gridTemplateColumns: "4%  7% 4% 7%  8% 61% 6% 3%",
  marginBottom: "2px",
  background: bkCeldaGrilla,
  height: "6.8vh",
  overflow: "hidden"
};


const Scelda = {
  borderBottom: bbottomGrilla,
  padding: "5px 2px 5px 2px",
  fontSize: sizeCelda,
  color: clCeldaGrilla
};

const ScabInc = {
  display: "grid",
  gridTemplateColumns: "4%  7% 4% 7% 8% 61% 6% 3%",
  marginLeft: "5px",
};
